import { NAME_OR_TAG_KEY } from '~/components/_layout/popovers/upload/constants';

export const stringifyFilters = (filter: string): string => {
  return filter ? JSON.stringify({ [NAME_OR_TAG_KEY]: filter }) : '';
};
